import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { createMaintenance, verifyVehicleMaintenance } from "../../../../common/services/maintenance.api";
import FormCreateMaintenance from "../forms/FormCreateMaintenances";
import { useState } from "react";
import { IVehicle } from "../../../../types/vehicle.type";
import { OverdueAlertModal } from "./OverdueWarningModal";

type Props = {
  onClosed: () => void;
  onSave: (maintenanceId: string) => void;
  licensePlate?: string
  readonly?: boolean
}

export default function ModalCreateMaintenance(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const handleCloseModal = () => { props.onClosed && props.onClosed() }
  const [vehicleAnotherCompany, setVehicleAnotherCompany] = useState(false);
  const [vehicle, setVehicle] = useState<IVehicle>();
  const [city, setCity] = useState<string>('');
  const [overdueWarningModal, setOverdueWarningModal] = useState<boolean>(false);

  async function handleSubmit(dataToSave) {

    try {

      const result = await createMaintenance(dataToSave);
      const { ok, data } = result;

      if (!ok && result["hasPendingPayments"]) {
        setOverdueWarningModal(true);
      }

      if (ok && data) {
        props.onSave((data as { _id: string })?._id);
        notifySuccess(`Manutenção "${(data as { licensePlate: string })?.licensePlate}" criado com sucesso!`);
        return;
      }
      if (!result.ok && result.message) {
        notifyError(result.message as string)
      }

    } catch (err) {
      if ((err as Error).message) {
        notifyError((err as Error).message as string)
      }
    }
  }

  async function handleVerifySubmit(dataToSave) {

    try {

      const resultVerify = await verifyVehicleMaintenance(dataToSave.licensePlate);
      if (resultVerify && resultVerify.data.vehicleAnotherCompany) {
        setVehicle(resultVerify.data.vehicle);
        setCity(resultVerify.data.city);
        setVehicleAnotherCompany(true);
        return;
      }
      handleSubmit(dataToSave);

    } catch (err) {
      if ((err as Error).message) {
        notifyError((err as Error).message as string)
      }
    }
  }

  return (
    <>
      <Modal
        className="relative dark:text-black"
        show={true}
        onClose={() => handleCloseModal()}
      >
        <Modal.Header>
          <h3 className="dark:text-black">{'Cadastrar nova Manutenção'}</h3>
        </Modal.Header>
        <Modal.Body>
          <FormCreateMaintenance readonly={props.readonly} licensePlate={props.licensePlate} city={city} vehicle={vehicle} vehicleAnotherCompany={vehicleAnotherCompany} onSubmit={vehicleAnotherCompany ? handleSubmit : handleVerifySubmit} />
        </Modal.Body>
      </Modal>

      <OverdueAlertModal
        isOpen={overdueWarningModal}
        onClose={() => setOverdueWarningModal(false)}
      />
    </>
  );
}